<div style="padding-right: 1rem;" class="eyeicon-scroll-container"
  infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">

  <app-candidate-job-details class="candidateJobContent" *ngIf="(response | async)?.length > 0" [showInteractiveButton]="true"
    [contentType]="'JA'" [interactionResponse]="response | async" [page]="page" (nextPage)="pagecount($event)"
    [totalCount]="totalCount"></app-candidate-job-details>

  <app-common-skeleton *ngIf="loadAPIcall && (response | async)?.length > 0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

  <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (response | async)?.length > 0" style="text-align: center;padding-top: 1rem;">
    <div class="col-sm-12">
      <ng-icon name="tablerCircleCheck"></ng-icon>
    </div>
    <div class="col-sm-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div>

  <div class="col-12" *ngIf="loadAPIcall && (response | async)?.length == 0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>

  <div class="col-sm-12" *ngIf="!loadAPIcall && loaddata && (response | async)?.length == 0">
    <div class="gs-empty">
      <span class="gs-empty-icon"><ng-icon name="tablerInbox"></ng-icon></span>
      <div class="gs-empty-title">No invites yet</div>
      <div class="gs-empty-sub">Invites will show up here as they arrive.</div>
    </div>
  </div>
</div>
